//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '~/node_modules/vue-range-component/dist/vue-range-slider.css';

export default {

  data: function () {
    const prices = this.filter || {};
    const min = prices.minPrice;
    const minValue = Boolean(this.selected?.[0] && this.selected?.[0] > -1) ? this.selected?.[0] : +prices.minPrice;
    const max = prices.maxPrice;
    const maxValue = Boolean(this.selected?.[1] && this.selected?.[1] > -1) ? this.selected?.[1] : +prices.maxPrice;
    const value = [minValue, maxValue];

    return {
      value: value,

      minValue: minValue,
      maxValue: maxValue,
      min: min,
      max: max,
      formatter: "",

      enableCross: false,
      tooltipMerge: false,

      timeOut: null,
      timeOutSend: null,

      isInit: false
    }
  },

  props: {
    filter: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected: {
      type: Array,
      default: () => {
        return []
      }
    },
  },

  watch: {
    value: async function () {
      await this.onChangeValue();
    }
  },

  components: {
    VueRangeSlider: () => import('vue-range-component-fixed')
  },

  methods: {

    onChangeValue: async function () {
      clearTimeout(this.timeOutSend);

      this.minValue = +this.value[0];
      this.maxValue = +this.value[1];
    },

    onChangeValueInputMin: function () {
      clearTimeout(this.timeOut)

      let newValue = [...this.value];
      newValue[0] = Number((String(this.minValue) || '').replace(/\D+/g, ""));

      this.timeOut = setTimeout(() => {
        this.value = newValue;
        this.$emit('change', this.value);
      }, 1000)
    },
    onChangeValueInputMax: function () {
      clearTimeout(this.timeOut)

      let newValue = [...this.value];
      newValue[1] = Number((String(this.maxValue) || '').replace(/\D+/g, ""));

      this.timeOut = setTimeout(() => {
        this.value = newValue;
        this.$emit('change', this.value);
      }, 1000)
    },

    submit: function () {
      clearTimeout(this.timeOutSend);
      this.timeOutSend = setTimeout(() => {
        this.$emit('change', this.value);
      }, 3000)
    }
  }

};
